import React, { useEffect, useState } from "react";
import "./Help.css";
import Header from "../Header/Header";
import Footer from "../Footer/Footer";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faQuestionCircle, faChevronDown, faChevronUp } from '@fortawesome/free-solid-svg-icons';
import { useTranslation } from 'react-i18next';
import { useDispatch } from "react-redux";
import { showRegister, store } from "../Redux/API";
import Searsh from '../Searsh/Searsh'
import { useSelector } from "react-redux";


const Help = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const [activeIndex, setActiveIndex] = useState(null);

    const toggleFAQ = (index) => {
        setActiveIndex(activeIndex === index ? null : index);
    };

    useEffect(() => {
        dispatch(store());
    }, [dispatch]);

    const faqs = t("faq_questions", { returnObjects: true }); // جلب الأسئلة المترجمة ككائنات
    const show_searsh = useSelector((state) => state?.products?.searsh);

    return (
        <>
            <Header />
            {show_searsh && (
                <Searsh />
            )}

            <div className="help-container container">
                <h4 className="help-title">{t("help_title")}</h4>
                <p className="help-intro">{t("help_intro")}</p>
                <div className="faq-section">
                    {faqs.map((faq, index) => (
                        <div key={index} className={`faq-item ${activeIndex === index ? "active" : ""}`}>
                            <div className="faq-question" onClick={() => toggleFAQ(index)}>
                                <FontAwesomeIcon icon={faQuestionCircle} className="faq-icon" />
                                {faq.question}
                                <FontAwesomeIcon icon={activeIndex === index ? faChevronUp : faChevronDown} className="toggle-icon" />
                            </div>
                            <div className={`faq-answer ${activeIndex === index ? "show" : ""}`}>
                                {faq.answer}
                            </div>
                        </div>
                    ))}
                </div>
                <div className="contact-support">
                    <p dangerouslySetInnerHTML={{ __html: t("contact_support") }}></p>
                </div>
            </div>
            <Footer />
        </>
    );
};

export default Help;